import { colorTokens } from "styles/globalStyles";
import type { SmsDispatchStatus } from "../hooks/useExcursionSmsDispatch";
import type { ExcursionSMSMessageStatus } from "api/smsTemplates/SMSTemplate.typed";

export type SmsDisplayStatus = SmsDispatchStatus | ExcursionSMSMessageStatus;

export type SmsStatusMeta = { label: string; color: string; rank: number };

export const SMS_STATUS_META: Record<SmsDisplayStatus, SmsStatusMeta> = {
  failed: { label: "Échec", color: colorTokens.status.danger, rank: 0 },
  cancelled: { label: "Annulé", color: colorTokens.status.danger, rank: 0 },
  not_sent: { label: "Non envoyé", color: colorTokens.status.danger, rank: 0 },
  denied: { label: "Refusé", color: colorTokens.status.danger, rank: 0 },
  undelivered: { label: "Non délivré", color: colorTokens.status.danger, rank: 0 },
  blacklisted: { label: "Refusé (STOP)", color: colorTokens.status.danger, rank: 1 },
  invalid: { label: "Numéro invalide", color: colorTokens.status.warning, rank: 1 },
  not_allowed: { label: "Non autorisé", color: colorTokens.status.warning, rank: 1 },
  flood: { label: "Anti-flood", color: colorTokens.status.warning, rank: 1 },
  no_phone: { label: "Sans numéro", color: colorTokens.status.warning, rank: 1 },
  moderated: { label: "En modération", color: colorTokens.status.info, rank: 2 },
  accepted: { label: "Transmis", color: colorTokens.status.info, rank: 3 },
  sending: { label: "Envoi…", color: colorTokens.text.muted, rank: 4 },
  pending: { label: "En attente", color: colorTokens.text.muted, rank: 4 },
  sent: { label: "Envoyé", color: colorTokens.status.info, rank: 5 },
  delivered: { label: "Délivré", color: colorTokens.status.success, rank: 5 },
};

const PROVIDER_DETAIL_LABELS: Record<string, string> = {
  NOT_ALLOWED: "Non autorisé",
  INVALID_DESTINATION: "Numéro invalide",
  INVALID_SENDER: "Expéditeur invalide",
  ROUTE_NOT_AVAILABLE: "Route indisponible",
  REJECTED: "Rejeté",
  NETWORK_ERROR: "Erreur réseau",
  EXPIRED: "Expiré",
  NOT_DELIVERED: "Non délivré",
};

export function smsStatusMeta(status: string): SmsStatusMeta {
  return (
    SMS_STATUS_META[status as SmsDisplayStatus] ?? {
      label: status,
      color: colorTokens.text.muted,
      rank: 4,
    }
  );
}

export function providerDetailLabel(details: string | undefined): string | undefined {
  const key = details?.trim().toUpperCase() ?? "";
  if (!key) return undefined;

  return PROVIDER_DETAIL_LABELS[key] ?? details;
}
